import React from 'react';
import { Box, Typography, Chip, Container } from '@mui/material';
import Navbar from '../components/Navbar';

const COMING_SOON_ITEMS = [
  { emoji: '⚖️', label: 'Position Comparison',     desc: 'Compare any two players at the same position side-by-side — QBs, WRs, RBs, DBs — across every advanced metric.',                            tier: 'nerds+' },
  { emoji: '🔍', label: 'Situational Play Explorer', desc: 'Filter any play situation — down, distance, formation, field zone — and instantly see EPA, success rate, and a full 32-team rankings table.', tier: 'nerds+' },
  { emoji: '🗺️', label: 'Drive EPA Explorer',        desc: 'EPA/play and success rate filtered by drive starting field position — see exactly where offenses click and where they stall.',                 tier: 'nerds+' },
  { emoji: '🎯', label: 'Situational QB Splits',     desc: 'Any QB, 15 splits: shotgun vs. under center, clean pocket vs. pressure, by down, quarter, and game script.',                                  tier: 'nerds+' },
  { emoji: '🔴', label: 'Red Zone Tendencies',       desc: 'Pass%, run%, EPA/play, TD rate, and goal-to-go behavior — all 32 teams, sort by any column.',                                                  tier: 'nerds+' },
  { emoji: '📐', label: 'Team Style Profiles',       desc: 'Radar charts of offensive and defensive identity — run-heavy, explosive, conservative, high-variance.',                                         tier: 'nerds+' },
  { emoji: '📈', label: 'Win Probability',           desc: 'In-game win probability curves for any matchup, with key momentum swing plays highlighted.',                                                    tier: 'nerds+' },
  { emoji: '🏆', label: 'Fantasy Projections',       desc: 'Data-driven weekly projections built on EPA, snap share, and target share — not just gut feel.',                                               tier: 'nerds+' },
  { emoji: '🌳', label: 'Route Tree Analysis',       desc: 'See which routes each WR/TE runs most, EPA by route type, and how defenses scheme against them.',                                              tier: 'nerds+' },
  { emoji: '⚗️', label: 'Theory Tester',             desc: 'Build and test your own football hypotheses against real play-by-play data.',                                                                   tier: 'nerds+' },
];

const TIER_CHIP = {
  'free':   { label: 'Free',   sx: { bgcolor: '#0a2a14', color: '#2ea84b', border: '1px solid #2ea84b55' } },
  'nerds+': { label: 'Nerds+', sx: { bgcolor: '#2a1a05', color: '#f5a623', border: '1px solid #f5a62355' } },
};

export default function ToolsPage() {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'transparent' }}>
      <Navbar />
      <Container maxWidth="md" sx={{ pt: 5, pb: 6 }}>
        {/* Header */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 900, color: '#e8f0f8', mb: 1 }}>
            🚧 Tools — Coming Soon
          </Typography>
          <Typography sx={{ color: '#6a8aa8', fontSize: '0.95rem', maxWidth: 560, mx: 'auto' }}>
            Advanced analytics tools currently in development. All tools require a Nerds+ subscription — but you can browse what's coming for free.
          </Typography>
        </Box>

        {/* Feature cards */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {COMING_SOON_ITEMS.map(item => {
            const chip = TIER_CHIP[item.tier];
            return (
              <Box key={item.label} sx={{
                backgroundColor: '#131318',
                border: '1px solid #1e2a3a',
                borderRadius: 2,
                px: 2.5, py: 2,
                display: 'flex', alignItems: 'flex-start', gap: 2,
                transition: 'border-color 0.15s',
                '&:hover': { borderColor: 'rgba(245,166,35,0.25)' },
              }}>
                <Typography sx={{ fontSize: '1.75rem', lineHeight: 1, mt: 0.25, flexShrink: 0 }}>
                  {item.emoji}
                </Typography>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                    <Typography sx={{ fontWeight: 800, fontSize: '1rem', color: '#e8f0f8' }}>
                      {item.label}
                    </Typography>
                    <Chip label={chip.label} size="small" sx={{ fontWeight: 800, fontSize: '0.62rem', height: 18, ...chip.sx }} />
                  </Box>
                  <Typography sx={{ color: '#6a8aa8', fontSize: '0.82rem', lineHeight: 1.55 }}>
                    {item.desc}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
}
